export const convertToCm = (ft: number = 0, inches: number = 0) => {
    return Math.round((ft * 12 + inches) * 2.54)
};

export const convertToKgWithoutRounding = (lbs: number = 0) => {
    return lbs / 2.20462262185;
};
